// Client API du PORTAIL CLIENT (Phase C) — endpoints publics `/api/v1/portail/*`.
//
// Instance axios DÉDIÉE, SANS l'intercepteur JWT Supabase de `apiClient` : le
// client n'est pas un utilisateur de la plateforme. L'authentification se fait
// par OTP puis par une session portail passée explicitement en Bearer.
import axios from "axios";

import { resolveBaseUrl } from "@/lib/api";

const portalClient = axios.create({ baseURL: resolveBaseUrl(), timeout: 15000 });

export interface PortailSession {
  session: string;
  dossier_id: number;
}

export interface PortailPiece {
  filename: string;
  categorie: string | null;
  statut: string | null;
}

export interface PortailDonnees {
  reference: string;
  objet_litige: string;
  statut: string;
  pieces: PortailPiece[];
}

/** Étape 1 — demande d'un code (réponse toujours générique côté serveur). */
export async function demanderAccesPortail(token: string, email: string): Promise<void> {
  await portalClient.post(`/api/v1/portail/${token}/demander-acces`, { email });
}

/** Étape 2 — vérifie le code et obtient une session cloisonnée au dossier. */
export async function verifierPortail(
  token: string,
  email: string,
  code: string,
): Promise<PortailSession> {
  const { data } = await portalClient.post<PortailSession>(
    `/api/v1/portail/${token}/verifier`,
    { email, code },
  );
  return data;
}

/** Étape 3 — données lecture seule du dossier autorisé par la session. */
export async function getPortailDonnees(session: string): Promise<PortailDonnees> {
  const { data } = await portalClient.get<PortailDonnees>("/api/v1/portail/donnees", {
    headers: { Authorization: `Bearer ${session}` },
  });
  return data;
}
